import * as React from "react";
import ReactDOM from "react-dom";
// theme
import ThemeConfig from "./theme";
import {
  Routes,
  Route,
  Link,
  useNavigate,
  useLocation,
  Navigate,
  Outlet,
} from "react-router-dom";
import api from "./services/api";
import Login from "./pages/login/Login";
import EsqueciMinhaSenha from "./pages/esqueci-minha-senha/EsqueciMinhaSenha";
import ConfirmaUsuario from "./pages/confirma-usuario/ConfirmaUsuario";
import Preenchimento from "./pages/preenchimento/Preenchimento";
import Graficos from "./pages/graficos/Graficos";
import GestaoCNAEs from "./pages/gestao-cnaes/GestaoCNAEs";
import GestaoEmpresasUsuarios from "./pages/gestao-empresas-usuarios/GestaoEmpresasUsuarios";
import AdminCNAEs from "./pages/admin-cnaes/AdminCNAEs";
import AdminArquivos from "./pages/admin-arquivos/AdminArquivos";
import AdminUsuariosGestores from "./pages/admin-usuarios-gestores/AdminUsuariosGestores";
import AdminUsuariosEmpresas from "./pages/admin-usuarios-empresas/AdminUsuariosEmpresas";
import Perfil from "./pages/perfil/Perfil";
import {
  Grid,
  Box,
  Card,
  Container,
  Typography,
  AppBar,
  Toolbar,
  Button,
  Avatar,
  Divider,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  IconButton,
  LinearProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PortraitIcon from "@mui/icons-material/Portrait";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useStoreState, useStoreActions } from "easy-peasy";
import MainMenu from "./MainMenu";
import { CSVDownload } from "react-csv";
import DialogoTermo from "./components/DialogoTermo";
import Tema03a from "../src/pages/preenchimento/03a/Tema03a";
import Tema01 from "../src/pages/preenchimento/01/Tema01";
import Tema02 from "../src/pages/preenchimento/02/Tema02";
import Tema03b from "../src/pages/preenchimento/03b/Tema03b";
import Tema04 from "../src/pages/preenchimento/04/Tema04";
import Tema05 from "../src/pages/preenchimento/05/Tema05";
import Tema06 from "../src/pages/preenchimento/06/Tema06";
import Tema07 from "../src/pages/preenchimento/07/Tema07";
import Tema08 from "../src/pages/preenchimento/08/Tema08";
import Tema09 from "../src/pages/preenchimento/09/Tema09";
import Tema10 from "../src/pages/preenchimento/10/Tema10";
import Tema11 from "../src/pages/preenchimento/11/Tema11";
import Tema12 from "../src/pages/preenchimento/12/Tema12";
import Tema00a from "../src/pages/preenchimento/00a/Tema00a";
import Tema00 from "../src/pages/preenchimento/00/Tema00";
import Tema13 from "../src/pages/preenchimento/13/Tema13";

function App() {
  const [firstLoad, setFirstLoad] = React.useState(false);
  let user = useStoreState((state) => state.auth.user);
  let setUser = useStoreActions((actions) => actions.auth.setUser);
  const navigate = useNavigate();
  const location = useLocation();
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);




  const Sistema = () => {
    let pages = [
      {
        label: "Preenchimento",
        link: "/preenchimento",
      },
    ];

    let canAccessGraficos = false;
    for (let i = 0; i < user?.temas.length; i++) {
      if (user.temas[i].id === "03a" || user.temas[i].id === "03b") {
        canAccessGraficos = true;
        break;
      }
    }
    if (canAccessGraficos) {
      pages.push({
        label: "Gráficos",
        link: "/graficos",
      });
    }

    if (["admin","gestor",'preenchedorSso'].includes(user.roleId)) {
      pages = [
        ...pages,
        {
          label: "Gestão",
          link: "/gestao",
          menu: [
            {
              label: "CNAEs",
              link: "/gestao/cnaes",
            },
            {
              label: "Empresas e Usuários",
              link: "/gestao/empresas-usuarios",
            },
          ],
        },
      ];
    }

    if (user.roleId == "admin") {
      pages = [
        ...pages,
        {
          label: "Admin",
          link: "/admin",
          menu: [
            {
              label: "CNAEs",
              link: "/admin/cnaes",
            },
            {
              label: "Facilitadores ESG",
              link: "/admin/usuarios-gestores",
            },
            {
              label: "Configurações",
              link: "/admin/arquivos",
            },
            {
              label: "Usuários e Empresas",
              link: "/admin/usuarios-empresas",
            },
          ],
        },
      ];
    }

    return (
      <div>
        <AppBar position="fixed" color="default">
          <Toolbar sx={{ py: 2 }}>
            <Box component="img" src="/logo-ibram.png" sx={{ height: 65 }} />
            <Box sx={{ mx: 4 }}>
              <MainMenu pages={pages} />
            </Box>
            <Box sx={{ flexGrow: 1 }} />
            <AuthStatus />
          </Toolbar>
        </AppBar>
        <Outlet />
      </div>
    );
  };

  const Layout = () => {
    let loading = useStoreState((state) => state.nav.loading);
    let openMessage = useStoreState((state) => state.nav.openMessage);
    let autoHideDuration = useStoreState((state) => state.nav.autoHideDuration);
    let message = useStoreState((state) => state.nav.message);
    let severity = useStoreState((state) => state.nav.severity);
    let closeMessage = useStoreActions((actions) => actions.nav.closeMessage);

    const handleErrorClose = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      closeMessage();
    };
    return (
      <ThemeConfig>
        {loading > 0 && <LinearProgress />}

        <Outlet />

        <Snackbar
          open={openMessage}
          autoHideDuration={autoHideDuration}
          onClose={handleErrorClose}
        >
          <Alert
            onClose={handleErrorClose}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>
      </ThemeConfig>
    );
  };

  const RequireAuth = ({ children }) => {
    let user = useStoreState((state) => state.auth.user);
    let location = useLocation();

    if (!user) {
      // // Redirect them to the /login page, but save the current location they were
      // // trying to go to when they were redirected. This allows us to send them
      // // along to that page after they login, which is a nicer user experience
      // // than dropping them off on the home page.
      return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if(!user.dataAceiteTermo) {
      return <Navigate to="/termo" state={{ from: location }} replace />;
    }

    return children;
  };

  React.useEffect(() => {
    api.http.get("auth-user").then(({data}) => {
      setUser(data)
    }).catch(() => {}).finally(() => {setFirstLoad(true);});
  }, []);

  if (firstLoad) {
    return (
      <Routes>
        <Route element={<Layout />}>
          <Route path="/login" element={<Login />} />
          {!user?.dataAceiteTermo && (
            <Route path="/termo" element={<DialogoTermo/>} />
          )}
          <Route path="/esqueci-minha-senha" element={<EsqueciMinhaSenha />} />
          <Route path="/confirma-usuario/:hash" element={<ConfirmaUsuario />} />
          <Route
            element={
              <RequireAuth>
                <Sistema />
              </RequireAuth>
            }
          >
            <Route path="/preenchimento" element={<Preenchimento />}>
              <Route path="00" element={<Tema00/>}/>
              <Route path="00a" element={<Tema00a/>}/>
              <Route path="01" element={<Tema01/>}/>
              <Route path="02" element={<Tema02/>}/>
              <Route path="03a" element={<Tema03a/>}/>
              <Route path="03b" element={<Tema03b/>}/>
              <Route path="04" element={<Tema04/>}/>
              <Route path="05" element={<Tema05/>}/>
              <Route path="06" element={<Tema06/>}/>
              <Route path="07" element={<Tema07/>}/>
              <Route path="08" element={<Tema08/>}/>
              <Route path="09" element={<Tema09/>}/>
              <Route path="10" element={<Tema10/>}/>
              <Route path="11" element={<Tema11/>}/>
              <Route path="12" element={<Tema12/>}/>
              <Route path="13" element={<Tema13/>}/>
            </Route>
            <Route path="/graficos" element={<Graficos />} />
            {user?.roleId != "usuario" && (
              <React.Fragment>
                <Route path="/gestao/cnaes" element={<GestaoCNAEs />} />
                <Route
                  path="/gestao/empresas-usuarios"
                  element={<GestaoEmpresasUsuarios />}
                />
              </React.Fragment>
            )}
            {user?.roleId == "admin" && (
              <React.Fragment>
                <Route path="/admin/cnaes" element={<AdminCNAEs />} />
                <Route
                  path="/admin/usuarios-gestores"
                  element={<AdminUsuariosGestores />}
                />
                <Route
                  path="/admin/usuarios-empresas"
                  element={<AdminUsuariosEmpresas />}
                />
                <Route path="/admin/arquivos" element={<AdminArquivos />} />
              </React.Fragment>
            )}
            <Route path="/perfil" element={<Perfil />} />
          </Route>
          <Route path="*" element={<Navigate to="/preenchimento" replace />} />
        </Route>
      </Routes>
    );
  } else {
    return <LinearProgress />;
  }
}

const AuthStatus = () => {
  let setUser = useStoreActions((actions) => actions.auth.setUser);
  let user = useStoreState((state) => state.auth.user);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  if (!user) {
    return "";
  }

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const sair = async () => {
    setAnchorEl(null);
    await api.signout();
    setUser(null);
  };

  const perfil = () => {
    navigate("/perfil");
  };

  return (
    <React.Fragment>
      <Tooltip title="Configurações da conta">
        <IconButton
          onClick={handleClick}
          size="large"
          color="secondary"
          sx={{ mr: 2 }}
          aria-controls={open ? "account-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          endicon={<KeyboardArrowDownIcon />}
        >
          <AccountCircleIcon fontSize="large" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        id="account-menu"
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1,
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 23,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={perfil}>
          <ListItemIcon>
            <PortraitIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Meu perfil</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem onClick={sair}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Sair</ListItemText>
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
};

export default App;
